import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'hpm-order-overview',
  templateUrl: './order-overview.component.html',
  styleUrl: './order-overview.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OrderOverviewComponent {}
